export const atLeastOneRequired = (label: string) => (value: string[]) =>
  value && value.length > 0 ? undefined : label;
